import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import user from './user/reducers'
import menu from './menu/reducers'
import settings from './settings/reducers'
import staff from './staff/reducers'
import vehicle from './vehicle/reducers'
import vendor from './vendor/reducers'
import driver from './driver/reducers'
import services from './services/reducers'
import fuel from './fuel/reducers'
import RootAction from './actions'

export default history => {
  const appReducer = combineReducers({
    router: connectRouter(history),
    user,
    menu,
    settings,
    staff,
    vehicle,
    vendor,
    driver,
    services,
    fuel,
  })
  return (state, action) => {
    if (action.type === RootAction.CLEAR_STATE) {
      state = undefined
    }
    return appReducer(state, action)
  }
}
